import * as React from 'react';
import {Box, Button} from '@mui/material';
import { NflSeason } from '../../../sdk/model';
import { nflSeasonApi } from '../../../adapters/APIExporter';
import SeasonConfig from './SeasonConfig';

function SeasonConfigs() {
  const [allSeasons, setAllSeasons] = React.useState<NflSeason[]>([]);
  
  React.useEffect(() => {
    nflSeasonApi.getAllNflSeasons().then(response => setAllSeasons(response.data));
  }, []);
  
  function updateSeason(seasonIndex, updatedSeason) {
    const newAllSeasons = [...allSeasons];
    newAllSeasons[seasonIndex] = updatedSeason;
    setAllSeasons(newAllSeasons);
  }
  
  function addSeason() {
    const newAllSeasons = [...allSeasons];
    newAllSeasons.unshift({});
    setAllSeasons(newAllSeasons);
  }
  
  function deleteSeason(seasonIndex) {
    const newAllSeasons = [...allSeasons];
    newAllSeasons.splice(seasonIndex, 1);
    setAllSeasons(newAllSeasons);
  }
  
  return <Box>
    <Button className='capsized-button' onClick={addSeason}>+ Add New Season</Button>
    <br/><br/>
    {allSeasons.map((season, seasonIndex) => <SeasonConfig key={seasonIndex + " " + season.seasonYear} season={season} updateSeason={(updatedSeason) => updateSeason(seasonIndex, updatedSeason)} deleteSeason={() => deleteSeason(seasonIndex)} />)}
  </Box>
}

export default SeasonConfigs;
